
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardContent from './components/DashboardContent';
import TeamsContent from './components/TeamsContent';
import TeamsTab from './components/TeamsTab';
import TeamsForms from './components/TeamsForms';
import Login from './components/Login';
import ViewActivityHistory from './components/ViewActivityHistory';
import LiveFeedExcelView from './components/LiveFeedExcelView';
import MainLayout from './components/MainLayout';
import TaskPage from './components/TaskPage';
import MembersContent from './components/Member/MembersContent';
import MembersCreate from './components/Member/MembersCreate';
import MembersEdit from './components/Member/MembersEdit';
import GoogleSheet from './components/GoogleSheet';
import DailyTask from './components/DailyTask';
import ProtectedRoute from './components/ProtectedRoute';
import { isLoggedIn } from "./components/utils/auth";
import Imesheet from './components/Sheets/Imesheet';
import Peersheet from "./components/Sheets/Peersheet";
import Phadsheet from "./components/Sheets/Phadsheet";
import Notifications from './components/Notifications';
import UserTimeReport from './components/UserTimeReport';
import TaskTimeReport from './components/TaskTimeReport';
import GoogleAuth from "./components/GoogleAuth";
import { Session } from './components/utils/session';
import { refreshJwtToken } from './components/utils/authService';
import DailyTaskList from './components/DailyTaskList';

function App() {
   const role = Session.getRole();
    useEffect(() => {
    const interval = setInterval(async () => {
    const expiry = Session.getExpiry();

    console.log("Expiry:", expiry);
    console.log("Remaining:", expiry - Date.now());
      if (!expiry)
        return;

      const remaining = expiry - Date.now();

      if (remaining <= 5 * 60 * 1000) {

        console.log("Refreshing JWT...");
        await refreshJwtToken();
      }

    }, 60000);

    return () => clearInterval(interval);

  }, []);
  return (
    
    <BrowserRouter>
      <Routes>

        {/* ROOT */}
        <Route
          path="/"
          element={
            !isLoggedIn() ? (
              <Navigate to="/login" replace />
            ) : role === "Super Admin" || role === "Admin" ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/dailytask" replace />
            )
          }
        />

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 PROTECTED ROUTES */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardContent />} />
          <Route path="/members" element={<MembersContent />} />
          <Route path="/teams" element={<TeamsContent />} />
          <Route path="/teams/create" element={<TeamsForms />} />
          <Route path="/teamsid/:id" element={<TeamsTab />} />
          <Route path="/ViewActivityHistory/:id" element={<ViewActivityHistory />} />
          <Route path="/excelview" element={<LiveFeedExcelView />} />
          <Route path="/googlesheet" element={<GoogleSheet />} />
          <Route path="/task" element={<TaskPage />} />
          <Route path="/Members/Create" element={<MembersCreate />} />
          <Route path="/Member/Edit/:id" element={<MembersEdit />} />
          <Route path="/dailytask" element={<DailyTask />} />
          <Route path="/Imesheet" element={<Imesheet />} />
          <Route path="/Peersheet" element={<Peersheet />} />
          <Route path="/Phadsheet" element={<Phadsheet />} />
          <Route path="/Notifications" element={<Notifications />} />
          <Route path="/usertimereport" element={<UserTimeReport />} />
          <Route path="/tasktimereport" element={<TaskTimeReport />} />
          <Route path="/GoogleAuth" element={<GoogleAuth />} />
         <Route path="/dailytasklist" element={<DailyTaskList  />} />
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;